<template>
    <!--Edit-->
    <div class="container">
        <div class="page-inner">
            <div class="page-header">
                <h3 class="fw-bold mb-3">Sinistros</h3>
            </div>
            <div class="row">
                <div class="col-md-12" v-if="Sinistro!=''">
                    <div class="card">
                        <div class="card-body">
                            <v-tabs v-model="tab" color="deep-purple-accent-4" bg-color="#dadcdf">
                                <v-tab value="dados" class="tabinfo"
                                    style="font-size: 13px;text-transform: none !important;">Acordo Sinistro</v-tab>
                            </v-tabs>
                            <v-window v-model="tab">
                                <v-window-item value="dados">
                                    <v-form>
                                        <v-container>
                                            <div class="row">
                                                <v-col cols="12" md="8">
                                                    <v-card style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                Dados Cliente
                                                            </h5>
                                                             <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Garantidora:</strong> {{ this.SinistroAcordo.garNome
                                                                }} - <strong>Imobiliária:</strong> {{ this.SinistroAcordo.imoNome
                                                                }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cliente:</strong> {{ this.SinistroAcordo.pedDescricao
                                                                }} <v-icon @click="dialogCliente = true;">mdi-folder-open</v-icon>
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Data Inicial:</strong> {{
                                                                formattedDate(this.SinistroAcordo.snaDtInclusao) }}  -  <strong>Contratação:</strong>  {{ SinistroAcordo.pedId
                                                                }}
                                                            </p>                                                    
                                                        </div>
                                                    </v-card>
                                                    <v-card style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <p class="texto-mensagem mb-0"
                                                            style="color:#333333;font-size: 14px;">
                                                            <strong>Status:</strong> {{ SinistroAcordo.statusAcordo }}
                                                        </p>
                                                        <div v-if="podeCancelarAcordo" class="form-group" style="margin-top: 15px;">
                                                            <label>Observacao Cancelamento</label>
                                                            <textarea v-model="observacaoCancelamento"
                                                                class="form-control"
                                                                rows="3"
                                                                maxlength="500"
                                                                placeholder="Informe o motivo do cancelamento"></textarea>
                                                        </div>
                                                        <button v-if="podeCancelarAcordo" type="button" class="btn btn-danger"
                                                            style="color:#ffffff;margin-top: 15px;"
                                                            :disabled="cancelandoAcordo"
                                                            @click.prevent="CancelarAcordo()">
                                                            {{ cancelandoAcordo ? 'Cancelando...' : 'Cancelar Acordo' }}
                                                        </button>
                                                    </v-card>
                                                      <v-card v-if="PedidosEndereco != ''" style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">Endereço
                                                                Contratação
                                                            </h5>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Endereço:</strong> {{
                                                                    PedidosEndereco[0].pdcEndereco
                                                                }}, {{ PedidosEndereco[0].pdcNumero }} - {{
                                                                    PedidosEndereco[0].pdcComplemento }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Cidade/UF:</strong> {{
                                                                    PedidosEndereco[0].pdcCidade }} /
                                                                {{ PedidosEndereco[0].pdcEstado }} -   <strong>Bairro:</strong> {{
                                                                    PedidosEndereco[0].pdcBairro
                                                                }} -  <strong>CEP:</strong> {{
                                                                    PedidosEndereco[0].pdcCep }}
                                                            </p>
                                                            <p class="texto-mensagem mb-0"
                                                                style="color:#333333;font-size: 14px;">
                                                                <strong>Tipo Imóvel:</strong> {{
                                                                    PedidosEndereco[0].pdcTipo
                                                                }} {{ PedidosEndereco[0].pdcResidencialTipo
                                                                }}
                                                            </p>
                                                        </div>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="4">
                                                      <v-card v-if="SinistroAcordoSinistro != ''" style="padding: 15px;margin-top: 5px;" color="#f7f7f7">
                                                        <v-table style="background-color: transparent;">
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left">
                                                                            Id
                                                                        </th>
                                                                        <th class="text-left">
                                                                            Sinistros
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item, index) in SinistroAcordoSinistro"
                                                                        :key="index">
                                                                        <td>{{ item.sntId }}</td>
                                                                        <td>{{ item.sntCodigo }}</td>
                                                                    </tr>
                                                                </tbody>
                                                        </v-table>
                                                    </v-card>
                                                </v-col>
                                                <v-col cols="12" md="12">
                                                     <v-card style="padding: 15px;" color="#f7f7f7">
                                                        <div>
                                                            <h5 class="subtitulo" style="padding-bottom: 15px;">
                                                                 Informações Parcelamento
                                                            </h5>
                                                        </div>
                                                         <v-row style="padding-top: 5px;padding-bottom: 5px;" v-if="SinistroTitulos.length > 0" >
                                                              <v-table style="background-color: transparent;">
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="text-left">
                                                                                Acordo
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Parcela
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Valor
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Vencimento
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Juros %
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Mora %
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Forma Pgto
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Status
                                                                            </th>
                                                                            <th class="text-left">
                                                                                Visualização
                                                                            </th>
                                                                             <th class="text-left">
                                                                                Ações
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-for="(item, index) in SinistroTitulos"
                                                                            :key="index">
                                                                            <td>{{ item.snaId }}</td>
                                                                            <td>{{ item.sttDescricao }}</td>
                                                                            <td>{{ formatarValor(item.sttValorPrincipal) }}</td>
                                                                            <td>{{ formattedDate(item.sttDtVencimento) }}</td>
                                                                            <td>{{ formatarDecimal(item.sttPercJuroDiario) }}</td>
                                                                            <td>{{ formatarDecimal(item.sttValorMora) }}</td>
                                                                            <td>{{ item.mpgNome }}</td>
                                                                            <td>{{ item.stlNome }}</td>
                                                                             <td style="text-align: center;">
                                                                                <v-btn icon v-if="item.stbNomeInterno != '' && item.stbNomeInterno != null && item.stlId == 10"
                                                                                    @click.prevent="VisualizarDocumento(item.stbNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar Documento</v-tooltip>
                                                                                </v-btn>
                                                                                 <v-btn icon v-if="item.stlId == 20 && item.stdNomeInterno != '' && item.stdNomeInterno != null"
                                                                                    @click.prevent="VisualizarDocumento(item.stdNomeInterno)"
                                                                                    variant="text">
                                                                                    <v-icon>mdi-eye</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Visualizar Comprovante</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                              <td style="text-align: center;">
                                                                                <v-btn icon v-if="!acordoCancelado && ((item.stbNomeInterno == '' || item.stbNomeInterno == null) && item.stlId == 10)"
                                                                                    @click.prevent="OpenModalDoc(item)"
                                                                                    variant="text">
                                                                                    <v-icon style="color:blue">mdi-file-upload</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Adicionar Boleto</v-tooltip>
                                                                                </v-btn>
                                                                                <v-btn icon v-if="!acordoCancelado && item.stbNomeInterno != '' && item.stbNomeInterno != null && item.stlId == 10"
                                                                                    @click.prevent="RemoverDocumento(item.stbId)"
                                                                                    variant="text">
                                                                                    <v-icon style="color:red">mdi-file-remove</v-icon>
                                                                                    <v-tooltip activator="parent"
                                                                                        location="top">Excluir Boleto</v-tooltip>
                                                                                </v-btn>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                            </v-table>
                                                         </v-row>
                                                    </v-card>
                                                </v-col>
                                            </div>
                                        </v-container>
                                    </v-form>
                                </v-window-item>
                            </v-window>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

     <!--modal Cliente-->
        <v-row justify="center">
            <v-dialog v-model="dialogCliente" class="controlcelEnd" transition="dialog-bottom-transition" width="auto">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Informações do Cliente</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                    <v-col v-if="Cliente != ''" cols="12" md="6"
                                        style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeEmpresa }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF/CNPJ: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliDocumento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Razão Social: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliRazaoSocial }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">Responsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliResponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3" v-if="Cliente.tpdId == 2">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;" v-if="Cliente.tpdId == 2">
                                                <span>{{ Cliente.cliCampoExtra1 }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefone }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsapp }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmail }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimento) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivil }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col v-if="Endereco != ''" cols="12" md="6">
                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <span style="font-weight: 500;">Endereço Alternativo: </span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleEndereco }} - {{ Endereco.cleNumero }} - {{
                                                    Endereco.cleComplemento }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Cidade/UF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCidade }} / {{ Endereco.cleEstado }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Bairro: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleBairro }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CEP: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Endereco.cleCep }}</span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfConjuge && Cliente.cliCpfConjuge != '' && Cliente.cliCpfConjuge != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Conjuge: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailConjuge }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoConjuge) }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto1"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col
                                        v-if="Cliente != '' && Cliente != null && Cliente.cliCpfCorresponsavel && Cliente.cliCpfCorresponsavel != '' && Cliente.cliCpfCorresponsavel != null"
                                        cols="12" md="6" style="border-right: 1px solid #cccccc;">
                                        <v-row>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Corresponsável: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">CPF: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliCpfCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Telefone: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliTelefoneCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Whatsapp: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliWhatsappCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">E-mail: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEmailCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Data Nascimento: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ formattedDate(Cliente.cliDataNascimentoCorresponsavel)
                                                    }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Estado Civil: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliEstadoCivilCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Pai: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomePaiCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Nome Mãe: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span>{{ Cliente.cliNomeMaeCorresponsavel }}</span>
                                            </v-col>
                                            <v-col cols="12" md="3">
                                                <span style="font-weight: 500;">Endereço: </span>
                                            </v-col>
                                            <v-col cols="12" md="9" style="text-align: left;">
                                                <span v-html="Cliente.cliTexto2"></span>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="dialogCliente = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>

         <!--modal documento-->
        <v-row justify="center">
            <v-dialog v-model="dialogDocumento" persistent class="controlcelEnd" transition="dialog-bottom-transition" width="auto">
                <v-card>
                    <v-card-title style="background-color: #cccccc;">
                        <span class="text-h5" style="font-size: 19px !important;">Upload do doc Pagamento</span>
                    </v-card-title>
                    <v-card-text style="padding: 16px 0px 10px">
                        <v-form>
                            <v-container>
                                <v-row>
                                     <v-col cols="12" md="12" style="text-align: center;">
                                            <label style="font-size: 25px !important;font-weight: 600;">{{DescricaoParcela}}</label>
                                    </v-col>
                                     <v-col cols="12" md="12">
                                        <div class="form-group">
                                            <label>Numero do código Barras</label>
                                            <input v-model="SinitroTituloBoleto.stbCodigoBarra" type="text" maxlength="100"
                                                class="form-control" />
                                        </div>
                                    </v-col>
                                    <v-col cols="12" md="12">
                                        <label for="exampleFormControlFile1">*JPG, JPEG, PNG ou
                                            PDF</label>
                                        <v-file-input v-model="selectedFileDebito"
                                            label="Selecione o arquivo" variant="underlined"
                                            prepend-icon="mdi-file"
                                            accept="image/*,application/pdf"></v-file-input>
                                    </v-col>
                                    <v-col cols="12" md="12" style="text-align: center;">
                                        <button type="button" class="btn btn-success"
                                            @click.prevent="AdicionarDocumento()"
                                            style="color:#ffffff;margin-top: 20px;">
                                            Salvar
                                        </button>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click.prevent="dialogDocumento = false">Fechar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
import moment from 'moment'
import { useRoute } from 'vue-router';

export default {
    name: 'SinistroAcordoDetalheView',
    components: {
        EasyDataTable,
        moment
    },
    setup() {
        const route = useRoute();
        const id = route.params.id;
        return {
            id,
        };
    },
    data: () => ({
        tab: null,
        User: {
            garid: 0,
            tpeid: 0,
            pesid: 0,
            cusid: 0
        },
        searchValue: '',
        MostraGrid: true,
        headers: [],
        SinistroAcordo:{},
        SinistroTitulos:[],
        //pedidoendereco
        PedidosEndereco: [],
        Cliente: {},
        Endereco: [],
        dialogCliente: false,
        dialogDocumento: false,
        SinitroTituloBoleto: {
            stbId: 0,
            sttId: 0,
            stbDtInclusao: null,
            stbNomeOriginal: '',
            stbNomeInterno: '',
            stbCodigoBarra: ''
        },
        DescricaoParcela: '',
        selectedFileDebito: '',
        SinistroAcordoSinistro: [],
        cancelandoAcordo: false,
        observacaoCancelamento: '',
    }),
    methods: {
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        preprocessData(data) {
            return data.map(item => {
                return {
                    ...item,
                    proOrdem: parseInt(item.proOrdem),
                };
            });
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(v) {
            const n = Number(v) || 0;
            return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        formatarDecimal(valor) {
            // Verifica se o valor é inteiro
            if (Number.isInteger(valor)) {
                return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            }
            // Formata normalmente para valores com casas decimais
            return parseFloat(valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/SinistroAcordoDetalhe/upload`, formData);
            return uploadResult;
        },
        buildFileUrl(path) {
            if (!path) return '';
            const rel = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/SinistroAcordoDetalhe/GetFileByParam?param=${encodeURIComponent(rel)}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
        VisualizarDocumento(item) {
            if (item) {
                this.openInNewTab(item);
            }
        },
        //enderecoPedido
        async SelecionarEnderecoPedido() {
            this.PedidosEndereco = [];
            await axios.get('/Telas/SinistroAcordoDetalhe/GetAllByPedIdEndereco/' + this.SinistroAcordo.pedId)
                .then(response => {
                    this.PedidosEndereco = response.data;
                    // console.log('PedidosEndereco')
                    // console.log(this.PedidosEndereco)
                })
                .catch(error => {
                    console.error(error);
                });


        },
        //Boleto
        OpenModalDoc(value){
          this.dialogDocumento=true;
          this.SinitroTituloBoleto.sttId = value.sttId;
          this.DescricaoParcela = value.sttDescricao;
        },
        async AdicionarDocumento(){
            if (!this.selectedFileDebito) {
                return this.$mensagemAviso("Selecione Documento");
            }
            if (this.SinitroTituloBoleto.stbCodigoBarra == '' || this.SinitroTituloBoleto.stbCodigoBarra == null ) {
                const result = await this.$mensagemConfirma('Confirma salvar sem codigo de barras?');
                if (!result?.isConfirmed) return;
            }

              try {
                    const uploadSuccess = await this.UploadImg(this.selectedFileDebito[0]);

                    if (uploadSuccess && uploadSuccess.data && uploadSuccess.data.nameFile) {
                        this.SinitroTituloBoleto.stbNomeOriginal = this.selectedFileDebito[0].name;
                        this.SinitroTituloBoleto.stbNomeInterno = uploadSuccess.data.nameFile;
                        this.SinitroTituloBoleto.stbDtInclusao = moment().format('YYYY-MM-DDTHH:mm:ss');
                        await axios.post('/Telas/SinistroAcordoDetalhe/AddSinistroAcordoBoleto', this.SinitroTituloBoleto);
                        this.dialogDocumento = false;
                        this.Get();
                    } else {
                        this.$mensagemErro("Erro inesperado ao processar o arquivo. Tente novamente.");
                    }
                } catch (error) {
                    // Trata erro retornado pelo backend (ex: BadRequest)
                    const mensagem = error.response?.data || "Erro ao enviar o documento.";
                    this.$mensagemErro(mensagem);
                }

        },
        async RemoverDocumento(value){
           const result = await this.$mensagemConfirma('Confirma exclusão desse boleto?');
           if (!result?.isConfirmed) return;
               await axios.delete('/Telas/SinistroAcordoDetalhe/DeleteSinistroAcordoBoleto/' +  value);
               this.Get();

        },
        async CancelarAcordo(){
            if (this.cancelandoAcordo) return;
            const observacao = String(this.observacaoCancelamento || '').trim();
            if (!observacao) {
                return this.$mensagemAviso('Informe a observacao do cancelamento.');
            }
            const result = await this.$mensagemConfirma('Confirma cancelar este acordo e enviar o saldo pendente para cobranca?');
            if (!result?.isConfirmed) return;

            try {
                this.cancelandoAcordo = true;
                await axios.put('/Telas/SinistroAcordoDetalhe/CancelarAcordo/' + this.SinistroAcordo.snaId, { observacao });
                this.$mensagemSucesso('Acordo cancelado com sucesso.');
                this.observacaoCancelamento = '';
                this.Get();
            } catch (error) {
                console.error(error);
                this.$mensagemErro('Nao foi possivel cancelar o acordo.');
            } finally {
                this.cancelandoAcordo = false;
            }
        },
        async Get() {
            var _id = '';
            if (this.id != '') {
                _id = this.id;
            }
          await axios.get(`/Telas/SinistroAcordoDetalhe/GetDados/` + _id)
            .then(response => {
                const d = response?.data ?? {};              
                const first = a => (Array.isArray(a) && a.length) ? a[0] : null;
                const asArr = v => Array.isArray(v) ? v : [];
                const toNum = v => (v == null || v === '') ? 0 : Number(String(v).replace(/\./g, '').replace(',', '.')) || 0;
                const sumBy = (list, selector) => asArr(list).reduce((acc, item) => acc + (selector(item) || 0), 0);

                // ───────── Atribuições seguras ─────────
                this.User.tpeid = d.tpeId ?? null;
                this.User.garid = d.garId ?? null;
                this.User.cusid = d.cusId ?? null;
                this.User.pesid = d.pesId ?? null;
                this.SinistroAcordo = d.sinistroAcordo ?? {};
                this.SinistroTitulos = asArr(d.sinistroTitulos);
                this.SinistroAcordoSinistro = asArr(d.sinistroAcordoSinistros);
                this.Cliente = d.cliente;
                this.Endereco = first(d.clienteEndereco) ?? {};
                // Chama só no final (se depender dos dados acima)
                if (this.SinistroAcordo != ''){
                 this.SelecionarEnderecoPedido?.();
                }

                //console.log('this.SinistroAcordo')
                //console.log(this.SinistroAcordo)
                console.log('this.SinistroTitulos')
                console.log(this.SinistroTitulos)
               //    console.log('this.ListaSinistroDocumentoHistorico')
               // console.log(this.ListaSinistroDocumentoHistorico)

            })
            .catch(err => {
                console.error('Erro ao buscar dados do sinistro:', err);
                // Defaults seguros em caso de erro
                this.SinistroAcordo = {};
            });

        }
    },
    created() {
        this.Get();
    },
    computed: {
        podeCancelarAcordo() {
            const status = String(this.SinistroAcordo?.statusAcordo || '').toUpperCase();
            return !!this.SinistroAcordo?.snaId && status !== 'CANCELADO' && status !== 'CUMPRIDO';
        },
        acordoCancelado() {
            const status = String(this.SinistroAcordo?.statusAcordo || '').toUpperCase();
            return status === 'CANCELADO';
        }
    },
}
</script>

<style scoped>
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}

.fontaprova {
    font-size: 16px;
    font-weight: 600;
}
</style>
